import { type TriageCardRow } from '@voll-intelligence/domain';

import { CustomerAvatar, ChannelChip, PriorityBadge } from '@web/ui/core/molecules';
import { formatHhMm, twcn } from '@web/ui/core/utils';

export function TriageRow({
  row,
  selected = false,
  onSelect,
}: Readonly<{
  row: TriageCardRow;
  selected?: boolean;
  onSelect: (cardId: TriageCardRow['cardId']) => void;
}>): React.JSX.Element {
  return (
    <li data-testid="triage-row" className="border-t border-border-soft first:border-t-0">
      <button
        type="button"
        onClick={() => {
          onSelect(row.cardId);
        }}
        data-active={selected ? 'true' : undefined}
        className={twcn(
          'grid w-full grid-cols-[auto_1fr] items-start gap-3 px-4 py-3.5 text-left transition-colors duration-base ease-standard',
          selected ? 'bg-primary-tint/55' : 'hover:bg-muted',
        )}
      >
        <span className="mt-0.5 flex-shrink-0">
          <CustomerAvatar name={row.customer.name} vip={row.customer.vip} size="md" />
        </span>
        <span className="flex min-w-0 flex-col gap-1">
          <span className="flex items-baseline justify-between gap-2 min-w-0">
            <span className="flex min-w-0 items-baseline gap-1.5">
              <span className="max-w-[30ch] truncate text-card-title font-medium tracking-display-soft text-foreground">
                {row.customer.name}
              </span>
              <span className="truncate text-xs text-muted-foreground">{row.company.name}</span>
            </span>
            <span className="flex-shrink-0 font-mono text-card-id text-faint-foreground tabular-nums">
              {formatHhMm(row.createdAt)}
            </span>
          </span>
          <span className="m-0 line-clamp-2 max-w-[80ch] text-meta leading-snug text-muted-foreground">
            {row.preview}
          </span>
          <span className="mt-0.5 flex flex-wrap items-center gap-1.5">
            <PriorityBadge priority={row.priority} />
            <ChannelChip channel={row.originChannel} />
          </span>
        </span>
      </button>
    </li>
  );
}
